<template>
  <component :is="tag">
    <slot/>
  </component>
</template>

<script>
// https://github.com/guanzo/vue-smooth-reflow#smooth-component
import smoothReflow from 'vue-smooth-reflow'

export default {
  name: 'SmoothReflow',
  mixins: [smoothReflow],
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    options: Object,
  },
  mounted() {
    this.$smoothReflow(this.options)
  },
}
</script>
